const elTransition =
  '.15s height ease-in-out, .15s padding-top ease-in-out, .15s padding-bottom ease-in-out, .15s margin-top ease-in-out, .15s margin-bottom ease-in-out'
const Transition = {
  'before-enter'(el) {
    el.style.transition = elTransition
    if (!el.dataset) el.dataset = {}

    el.dataset.oldPaddingTop = el.style.paddingTop
    el.dataset.oldPaddingBottom = el.style.paddingBottom
    el.dataset.oldMarginTop = el.style.marginTop
    el.dataset.oldMarginBottom = el.style.marginBottom

    el.style.height = 0
    el.style.paddingTop = 0
    el.style.paddingBottom = 0
    el.style.marginTop = 0
    el.style.marginBottom = 0
    el.style.overflow = 'hidden'
  },

  enter(el) {
    el.dataset.oldOverflow = el.style.overflow
    var swiperEl = null
    if (el.dataset && el.dataset.inSwiper) {
      swiperEl = document.querySelector('.swiper-wrapper')
    }
    if (el.scrollHeight !== 0) {
      el.style.height = el.scrollHeight + 'px'
      if (swiperEl && swiperEl.style) {
        swiperEl.style.height = swiperEl.style.height?.split('px')[0] - 0 + el.scrollHeight + 'px'
        swiperEl.style.transition = '.35s height ease-in-out'
      }
      el.style.paddingTop = el.dataset.oldPaddingTop
      el.style.paddingBottom = el.dataset.oldPaddingBottom
    } else {
      el.style.height = 0
      el.style.paddingTop = el.dataset.oldPaddingTop
      el.style.paddingBottom = el.dataset.oldPaddingBottom
    }
    el.style.marginTop = el.dataset.oldMarginTop
    el.style.marginBottom = el.dataset.oldMarginBottom
  },

  'after-enter'(el) {
    el.style.transition = ''
    // 修复内容高度动态变化的场景
    if (!el.dataset?.noHeight) {
      el.style.height = ''
    }
    el.style.overflow = el.dataset.oldOverflow
  },

  'before-leave'(el) {
    if (!el.dataset) el.dataset = {}
    var noHeight = el.dataset.noHeight
    el.dataset.oldPaddingTop = el.style.paddingTop
    el.dataset.oldPaddingBottom = el.style.paddingBottom
    el.dataset.oldMarginTop = el.style.marginTop
    el.dataset.oldMarginBottom = el.style.marginBottom
    el.dataset.oldOverflow = el.style.overflow
    // 修复首次收起没有动效
    if (!noHeight) {
      el.style.height = el.scrollHeight + 'px'
    }
    el.style.overflow = 'hidden'
  },

  leave(el) {
    if (el.scrollHeight !== 0) {
      el.style.transition = elTransition
      el.style.height = 0
      el.style.paddingTop = 0
      el.style.paddingBottom = 0
      el.style.marginTop = 0
      el.style.marginBottom = 0
      var swiperEl = null
      if (el.dataset && el.dataset.inSwiper) {
        swiperEl = document.querySelector('.swiper-wrapper')
      }
      if (swiperEl && swiperEl.style) {
        swiperEl.style.height = swiperEl.style.height?.split('px')[0] - 0 - el.scrollHeight + 'px'
        swiperEl.style.transition = '.3s height ease-in-out'
      }
    }
  },

  'after-leave'(el) {
    el.style.transition = ''
    if (!el.dataset?.noHeight) {
      el.style.height = ''
    }
    el.style.overflow = el.dataset.oldOverflow
    el.style.paddingTop = el.dataset.oldPaddingTop
    el.style.paddingBottom = el.dataset.oldPaddingBottom
    el.style.marginTop = el.dataset.oldMarginTop
    el.style.marginBottom = el.dataset.oldMarginBottom
  }
}

export default function Collapse(isGroup) {
  return {
    name: `collapse${isGroup ? '-group' : ''}`,
    functional: true,

    render(h, { children }) {
      const data = {
        on: Transition
      }
      return h(`transition${isGroup ? 'Group' : ''}`, data, children)
    }
  }
}
